import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import AllOpenTaskList from './AllOpenTaskList'
import * as action from '../../state/task-list/action'
import * as selector from '../../state/task-list/selector'
import { selectPartnerList } from '../../../globals/state/selector'

const mapStateToProps = (state, props) => {
    return {
        tableData: selector.selectTable(state),
        partnerList: selectPartnerList(state),
    }
}

const mapDispatchToProps = {
    initialTableQuery: action.initialTableQuery,
    changeFilter: action.changeFilter,
    toggleSort: action.toggleSort,
    toggleMultiSort: action.toggleMultiSort,
    gotoPage: action.gotoPage,
    initialColumnsVisibility: action.initialTableSettingsAllOpenTask,
    toggleColumnVisibility: action.toggleColumnVisibilityAllOpenTask,
    navigateToTaskDetail: (taskId) => {
        return push('/task/detail/' + taskId)
    },
}

export default connect(mapStateToProps, mapDispatchToProps)(AllOpenTaskList)



// WEBPACK FOOTER //
// ./src/modules/process/component/task-list/AllOpenTaskListContainer.js